export enum RssRouteName {
    Index = 'system.rss.index',
    Create = 'system.rss.create',
    Edit = 'system.rss.edit',
}

export default {
    path: 'rss',
    name: RssRouteName.Index,
    component: () => import('@/views/system/rss/Index.vue'),
    meta: {
        auth: true,
        label: 'RSS',
        icon: 'fal fa-rss-square fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: 'manage-rss',
    },
    children: [
        {
            path: 'create',
            name: RssRouteName.Create,
            component: () => import('@/views/system/rss/Index.vue'),
            meta: {
                auth: true,
                label: 'Create RSS',
                icon: 'fal fa-globe fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-rss',
            },
        },
        {
            path: ':rssId/edit',
            name: RssRouteName.Edit,
            component: () => import('@/views/system/rss/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit RSS',
                icon: 'fal fa-globe fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-rss',
            },
        },
    ],
}
